import React from 'react';

const GrammarStats = ({grammar}) => {
  if (!grammar) return null;
  const progress = Math.round((grammar.levelProgress || 0) * 100);
  const metrics = [['assignment_turned_in', grammar.totalMasteredCount || 0, 'Mastered'], ['today', grammar.remindTopicCount || 0, 'Due today'], ['library_books', grammar.totalRemindTopicCount || 0, 'In review'], ['trending_up', `${progress}%`, 'Progress']];
  return <section className="stats-card surface-card" aria-labelledby="grammar-stats-title">
    <div className="stats-card__heading"><span className="stats-card__icon stats-card__icon--teal"><i className="material-icons" aria-hidden="true">spellcheck</i></span>
      <div><h2 id="grammar-stats-title">Grammar</h2><p>Review topics before they fade.</p></div>
    </div>
    <div className="metric-grid">{metrics.map(([icon, value, label]) => <div className="metric-item" key={label}><i className="material-icons"
                                                                                                                    aria-hidden="true">{icon}</i><strong>{value}</strong><span>{label}</span>
    </div>)}</div>
    <div className="progress-label"><span>Level progress</span><strong>{progress}%</strong></div>
    <div className="progress-track"><span className="progress-track__fill progress-track__fill--teal" style={{width: `${progress}%`}}/></div>
  </section>;
};
export default GrammarStats;
